import { Icon } from "@/components/icon/icon";
import { t } from "@/context/language";
import { motion } from "framer-motion";

const MERRIWEATHER = { fontFamily: "var(--font-merriweather)" } as const;

type MetaPartnershipProps = {
  showSubtitle?: boolean;
};

export function MetaPartnership({ showSubtitle = true }: MetaPartnershipProps) {
  return (
    <div className="flex flex-col items-center gap-6 text-center">
      {/* Lockup Meta Business Partners */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <img
          src="/images/fidexa-meta-business-partners.png"
          alt="Meta Business Partners"
          width={308}
          height={50}
          className="h-8 w-auto sm:h-10"
        />
      </motion.div>

      {/* Título */}
      <motion.h2
        className="flex items-center justify-center gap-3"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <Icon
          icon="badgeCheck"
          className="size-8 shrink-0 sm:size-10 lg:size-12"
        />
        <span
          className="text-3xl font-bold text-black sm:text-4xl lg:text-5xl"
          style={MERRIWEATHER}
        >
          {t.meta.partnersPrefix}
          <span className="text-meta">{t.meta.partnersBrand}</span>
        </span>
      </motion.h2>

      {/* Subtítulo */}
      {showSubtitle && (
        <motion.p
          className="max-w-2xl text-base text-gray-700 sm:text-lg lg:text-xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          {t.meta.subtitle}
        </motion.p>
      )}
    </div>
  );
}
